import { render, staticRenderFns } from "./VipOrder.vue?vue&type=template&id=2d21dc8a&scoped=true"
import script from "./VipOrder.vue?vue&type=script&lang=js"
export * from "./VipOrder.vue?vue&type=script&lang=js"
import style0 from "./VipOrder.vue?vue&type=style&index=0&id=2d21dc8a&prod&scoped=true&lang=css"
import style1 from "./VipOrder.vue?vue&type=style&index=1&id=2d21dc8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d21dc8a",
  null
  
)

export default component.exports